import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { SnEvidenceUser } from '@lib/api/entities';
import { SnIntegrationsAPI } from '@lib/api/services';
import { SnCurrentUser } from '@lib/auth';

@Component({
  templateUrl: './associate-user-dialog.component.html',
  styleUrls: ['./associate-user-dialog.component.scss'],
})
export class AssociateUserDialogComponent implements OnInit, OnDestroy {
  public isLoading: boolean = false;
  public targetUser: SnEvidenceUser;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _currentUser: SnCurrentUser,
    private readonly _dialogRef: MatDialogRef<AssociateUserDialogComponent>,
    private readonly _integrationsAPI: SnIntegrationsAPI,
  ) {}

  public ngOnInit(): void {
    this.isLoading = true;
    this._integrationsAPI
      .getEvidenceUserList()
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: (response: SnEvidenceUser[]) => {
          this.isLoading = false;
          this.targetUser = response?.find(
            (user) => user?.email?.toLowerCase() === this._currentUser.email?.toLowerCase(),
          );
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submitForm(): void {
    if (!this.targetUser) {
      return;
    }
    this._integrationsAPI
      .associateUser(this.targetUser.id)
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        this._dialogRef.close(this.targetUser);
      });
  }

  public close(): void {
    this._dialogRef.close();
  }
}
